(() => {
  if (window.yunshoPublicMenuReady) return;
  window.yunshoPublicMenuReady = true;
  document.addEventListener('toggle', event => {
    if (!event.target.matches?.('.yunsho-learn-group')) return;
    const menu = event.target.closest('y-menu-element[data-yunsho-nav]');
    const panel = event.target.closest('ul[aria-current="true"]');
    if (menu && panel) requestAnimationFrame(() => menu.style.setProperty('--height', `${panel.offsetHeight + 1}px`));
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest?.('x-menu-element[data-yunsho-nav]');
    if (!menu) return;
    const trigger = menu.querySelector('.x-menu--level-1--link > a[aria-expanded="true"]');
    if (trigger && typeof menu.closeMenu === 'function') {
      trigger.focus();
      requestAnimationFrame(() => { if (menu.isConnected) menu.closeMenu(true); });
      event.preventDefault();
    }
  });
})();
